// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-6a0ac0a0] .el-popup-parent--hidden {\n  padding: 0 !important;\n}\n[data-v-6a0ac0a0] .el-popup-parent--hidden .fixed-header {\n  padding-right: 15px;\n}\n.app-main[data-v-6a0ac0a0] {\n  width: 100%;\n  height: calc(100vh - 86px);\n}", ""]);
// Exports
module.exports = exports;
